import {DASHBOARD__16, GEAR__16, HEART__16, LOG_OUT__16, MAIL__16, PERSON__16, SUITCASE__16} from '@homeaway/svg-defs';

export default {
    'dashboard': DASHBOARD__16,
    'door': LOG_OUT__16,
    'heart': HEART__16,
    'inbox': MAIL__16,
    'settings': GEAR__16,
    'suitcase': SUITCASE__16,
    'user': PERSON__16
};